<ng-template [ngIf]="exibicao === 'detalhamento'">
	<p-splitButton
		#btnAcao
		label="Ações"
		[model]="acoesPossiveis"
		[disabled]="desabilitar"
		styleClass="secondary"
		(onClick)="btnAcao.onDropdownButtonClick($event)"
	></p-splitButton>
</ng-template>

<ng-template [ngIf]="exibicao === 'tabela'">
	<p-menu #menu [model]="acoesPossiveis" [popup]="true"></p-menu>
	<button
		pButton
		type="button"
		class="br-button circle"
		aria-label="Ações"
		(click)="menu.toggle($event)"
		[disabled]="acoesPossiveis.length === 0"
		icon="fas fa-ellipsis-v"
	></button>
</ng-template>

<p-confirmDialog acceptLabel="Confirmar" rejectLabel="Cancelar"></p-confirmDialog>
